module.exports = __webpack_public_path__ + "static/media/Gentona Semi Bold.03fe64d1.otf";